import { useTranslation } from 'react-i18next'
import type { MuiTelInputCountry } from 'mui-tel-input'

/**
 * Centrální nastavení pro všechny MuiTelInput komponenty.
 * Přidat/odebrat země nebo změnit výchozí zemi jen zde.
 */
const DEFAULT_COUNTRY: MuiTelInputCountry = 'CZ'
const ONLY_COUNTRIES: MuiTelInputCountry[] = ['CZ', 'SK', 'PL', 'AT', 'DE']

/**
 * Hook vracející props pro MuiTelInput včetně překladu názvů zemí dle aktuálního jazyka.
 * Použití: <MuiTelInput {...useTelInputSettings()} ... />
 */
export function useTelInputSettings() {
    const { i18n } = useTranslation()
    return {
        defaultCountry: DEFAULT_COUNTRY,
        onlyCountries: ONLY_COUNTRIES,
        langOfCountryName: i18n.language,
    }
}
